export function shouldShowPageBackground(pathname: string): boolean {
  if (pathname === "/tutorial") return false;
  if (pathname.startsWith("/play/")) return false;
  if (pathname.startsWith("/replay/")) return false;
  return true;
}
